var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"offline-banner",attrs:{"id":"offline-banner"}},[_vm._v("You are offline")]),_vm._v(" "),_c('router-view',{on:{"authenticated":_vm.$store.getters.isAuthenticated}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }